import {
    FeedPostDropDown,
    PostMedia2,
    PostText,
    PostUserBlock,
    SocialCount
} from "ui";
import ThreadSubPost from "./ThreadSubPost";
import { CustomComponentProps } from "utils/types/generalTypes";
import { Link } from "react-router-dom";

export type ThreadPostProps = CustomComponentProps & {
    showThreads?: boolean;
};

const ThreadPost = ({ showThreads = false }: ThreadPostProps) => {
    return (
        <div className="card thread-post">
            <div className="card is-post mb-20 mt-20">
                {/* <!-- Main wrap --> */}
                <div className={`content-wrap`}>
                    <div className="p-relative">
                        <div
                            className={`thread-post-v-line ${!showThreads ? "main-thread" : ""}`}
                        ></div>
                        {/* <!-- Post header --> */}
                        <div className="card-heading">
                            {/* <!-- User meta --> */}
                            <PostUserBlock />
                            {/* Right side dropdown */}
                            <FeedPostDropDown />
                        </div>
                        {/* <!-- /Post header --> */}

                        <div className="thread-post-body">
                            {/* <!-- Post body --> */}
                            <div className="card-body">
                                {/* <!-- Post body text --> */}
                                <PostText text="Yesterday with @Karen Miller and @Marvin Stemperd at the #Rock'n'Rolla concert in LA. Was totally fantastic! People were really excited about this one!" />
                                {/* <!-- Featured image --> */}
                                <PostMedia2 />
                            </div>
                            {/* <!-- /Post body --> */}

                            {/* <!-- Post footer --> */}
                            <div className="card-footer">
                                {/* <!-- Followers avatars --> */}
                                <SocialCount />
                            </div>
                        </div>
                        {/* <!-- /Post footer --> */}
                        {!showThreads ? (
                            <div className="card-heading">
                                {/* <!-- User meta --> */}
                                <PostUserBlock />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    {!showThreads ? (
                        <div className="card-heading">
                            <Link
                                to="/thread"
                                className="cursor-pointer blue-text"
                                // onClick={() => setShowThreads(true)}
                            >
                                Show This Post
                            </Link>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {/* <!-- /Main wrap --> */}
            </div>
            {showThreads ? (
                <>
                    <ThreadSubPost />
                    <ThreadSubPost />
                    <ThreadSubPost lastThread={true} />
                </>
            ) : (
                ""
            )}
        </div>
    );
};

export default ThreadPost;
